import { createApp } from 'vue';
import Cloudinarize from '@plugins/cloudinarize';
import KFormField from '@components/forms/form_field.vue';
import KInput from '@components/inputs/input.vue';
import PasswordMeter from '@components/password-meter.vue';
import Recaptcha from '@components/recaptcha.vue';
import Box from '@components/box.vue';
import { getEnvVar, initSentry } from '@utils';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import ConfirmationHint from '@mixins/confirmationHint';
import ShowPassword from '@mixins/showPassword';
import Loader from '@components/loader/loader.vue';

initSentry();

const app = {
  components: {
    KFormField,
    KInput,
    PasswordMeter,
    Recaptcha,
    Box,
    Loader,
  },
  mixins: [ConfirmationHint, ShowPassword],
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      loading: false,
    };
  },
  methods: {
    submitForm() {
      this.loading = true;
      // eslint-disable-next-line no-undef
      document.getElementById('provider-registration-form').requestSubmit();
    },
  },
  mounted() {
    setInterval(window.initSignUp, 500);
  },
};

createApp(app)
  .use(VueReCaptcha, {
    siteKey: getEnvVar('RECAPTCHA_SITE_KEY'),
    loaderOptions: {
      renderParameters: {
        badge: 'bottomleft',
      },
    },
  })
  .use(Cloudinarize)
  .mount('.register--new-provider');
